<div [ngClass]="{'error-display': isShow, 'error-hide': !isShow}" [innerHtml]="errorMessage | newLine">
</div>
